import { render } from "./WidgetsTab.vue?vue&type=template&id=30b4b6b2&scoped=true"
import script from "./WidgetsTab.vue?vue&type=script&lang=js"
export * from "./WidgetsTab.vue?vue&type=script&lang=js"

import "./WidgetsTab.vue?vue&type=style&index=0&id=30b4b6b2&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b4b6b2"]])

export default __exports__